import {json} from '../../../core/data-source/json.mapper';

export class VehicleChecksFieldRecord {
    @json({
        skip: true
    })
    reference: string;

    @json()
    name: string;

    @json()
    description: string;

    @json()
    type: string;

    @json({
        value: [],
        jsonName: 'values'
    })
    values: string[];

    @json()
    mandatory: boolean;

    // custom field
    @json({
        skip: true
    })
    rowId: number;
}
